import { environment } from "src/environments/environment";
const baseUrl = environment.API_URL;
export const paymentAPI = {
  //added Apple PAy option
  APPLE_PAY_VALIDATION_SESSION: `${baseUrl}orders/applepay-validate-session`,
  APPLE_PAY_STRIPE_URL_VALIDATION: `${baseUrl}orders/apple-pay-with-stirpe-domain-validation`,
  STRIPE_URL_PAY: `${baseUrl}orders/stirpe-payment-intent`,
  SAVE_STRIPE_TRANDSCTION_ID: `${baseUrl}orders/store-transaction-id`,
  CHECKOUT_URL_PAY: `${baseUrl}orders/checkout-payment`,
  BRAINTREE_CLIENT_INIT: `${baseUrl}orders/get-braintree-client-token`,
  BRAINTREE_URL_PAY: `${baseUrl}orders/braintree-payment`,
  CYBERSOURCE_URL_PAY: `${baseUrl}orders/cybersource-card-payment`,
  NI_URL_PAY: `${baseUrl}orders/network-international-payment`,
  APPLE_PAY_NI: `${baseUrl}orders/apple-pay-ni-intent`,
};
export const API = {
  //added Apple PAy option
  ADD_USER_ADDRESS: `addresses`,
  GET_USER_PROFILE: `getmyprofile`,
  PROMOCODE: `applypromocode/retailer/`,
  CATEGORY: `webapp/retailer/`,
  COUNTRY: `addresses/getcountry`,
  GET_SUBDOMAIN_DATA: `get-retailer-from-subdomains/`,
  SENT_NOTIFICATION: `orders/store-webapp-notification`,
  LOGIN: `newlogin`,
  REGISTRED: `users`,
  ORDER_PLACE: `orders`,
  USERORDERS: `user-orders`,
  ORDER_STATUS_UPDATE: `orders/order-status-change/retailer/`,
  PRODUCT: `products`,
  DELIVERYPRODUCT: `deliveryproducts`,
  GET_IMAGE: `webapp/get-image-data`,
  RETAILER: `retailers/`,
  RETAILERS_CATEGORIES: `retailer-categories/`,
  RETAILERS: `retailers`,
  USERLOCATIONOROUTLET: `get-location/`,
  SEARCHPRODUCT: `search-products`,
  TRACKCTACLICK: `track-cta-click`,
  TRACKWEBAPPVISIT: `track-webapp-visit`,
  TRACKOUTLETCLICK: `track-outlet-click`, // For outlet which is in venue
  TRACKPOPUPCLICK: `track-redirect-click`,
  STOREBASKET: `user-basket/store`,
  CHECKFORBASKET: `user-basket/check`,
  FETCHBASKET: `user-basket/retrieve`,
  DELETEBASKET: `user-basket/delete`,
  GETORDERDETAIL: `user-order`,
  GETUSEROUTLET: `user-order-retailers`,
  GETREFERRALUSEROUTLET: `user-referral-retailers`,
  CREATEREFERRALCODE: `referral-code/create`,
  GETREFERRALCODES: `referral-code`,
  CHECKREFERRALCODES: `referral-exist`,
  GETUSERTOKENTRANSACTION: `get-toodle-token-list`,
  GETUSERTOKENBALANCE: `get-total-token-balance`,
  GETSELECTEDLOCATION: `user-location`,
  SETSELECTEDLOCATION: `user-location/store`,
  GETPROMOLIST: `get-welcome-notifcation-list`,
  GETPROMODETAILS: `get-welcome-notifcation-detail`,
  GETVENUEOUTLETLIST: `multioutlet/retailers-list`,
  GETVENUE_SHOW_SAVE_OUTLETS: `get-venue-show-save-outlets`,
  SENDFEEDBACKFORM: `multioutlet/send-retailers-user-feedback`,
  SENDFEEDBACKFORMSINGLEOUTLET: `retailer/send-retailers-user-feedback`,
  HOME_SCREEN_LAYOUT: `home-screen-layout`,
  HOME_SCREEN_LAYOUT_UPDATE: `home-screen-layout/update`,
  UPLOAD_INSTRUCTION_IMAGE: `orders/upload-instruction-image`,
};
